import { useEffect, useContext, useState } from "react";
import { io } from "socket.io-client";
import { MyForm } from "./components/form";
import { MusicPlayer } from "./components/musicPlayer";
import StateContext from "./StateContext";
import { Playlist } from "./components/playlist";
import {
  ResponseCurrentMusicGet,
  ResponseCurrentMusicNewTimeCode,
  ResponseCurrentMusicPlay,
  ResponseCurrentPlaylistGet,
  ResponseCurrentPlaylistNewOrder,
  ResponsePlaylistList,
  ResponseServer,
  ResponseUserConnected,
} from "./types/serverResponse.type";
import { RequestFactory } from "./libs/services";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

export const serverUrl =
  process.env.REACT_APP_SERVER_URL ?? "http://localhost:4000";
console.log("serverUrl = ", serverUrl);
export const socket = io(serverUrl);

function App() {
  const [loading, setLoading] = useState(false);
  const context = useContext(StateContext);

  const {
    audioRef,
    setPlayMusic,
    currentPlaylist,
    setCurrentPlaylist,
    setCurrentMusic,
    volume,
    setListPlaylist,
  } = context || {};

  useEffect(() => {
    RequestFactory.currentPlaylist.get();
    RequestFactory.currentMusic.get();
    RequestFactory.playlist.getAll();

    socket.on("message", (data: ResponseServer) => {
      console.log("data = ", data);
      if (data.target === "CURRENT_PLAYLIST") {
        if (data.response === "GET") {
          const payload = (data as ResponseCurrentPlaylistGet).payload;
          if (currentPlaylist?.id !== payload.playlist.id) {
            setCurrentPlaylist(payload.playlist);
          }
        } else if (data.response === "NEW_ORDER") {
          const payload = (data as ResponseCurrentPlaylistNewOrder).payload;
          if (payload.senderId !== socket.id)
            setCurrentPlaylist(payload.playlist);
        }
      }
      if (data.target === "CURRENT_MUSIC") {
        if (data.response === "PLAY") {
          const payload = (data as ResponseCurrentMusicPlay).payload;
          const timeLeft = payload.executionTime - new Date().getTime();
          setTimeout(function () {
            setPlayMusic(true);
            audioRef.current?.play();
            audioRef.current!.currentTime = payload.musicTimeCode;
            audioRef.current!.volume = volume;
          }, timeLeft);
        } else if (data.response === "PAUSE") {
          const payload = (data as ResponseCurrentMusicPlay).payload;
          const timeLeft = payload.executionTime - new Date().getTime();
          setTimeout(function () {
            setPlayMusic(false);
            audioRef.current?.pause();
            audioRef.current!.currentTime = payload.musicTimeCode;
            audioRef.current!.volume = volume;
          }, timeLeft);
        } else if (data.response === "GET") {
          const payload = (data as ResponseCurrentMusicGet).payload;
          setCurrentMusic(payload.music);
        } else if (data.response === "NEW_TIME_CODE") {
          const payload = (data as ResponseCurrentMusicNewTimeCode).payload;
          if (payload.senderId !== socket.id)
            audioRef.current!.currentTime = payload.timeCode;
        }
      }
      if (data.target === "PLAYLIST") {
        if (data.response === "LIST_PLAYLIST") {
          const payload = (data as ResponsePlaylistList).payload;
          setListPlaylist(payload.playlists);
        }
      }
      if (data.target === "USER_CONNECTED") {
        const payload = (data as ResponseUserConnected).payload;
        setNumberOfUserConnected(payload.numberOfUsers);
      }
    });
  }, []);

  const [numberOfUserConnected, setNumberOfUserConnected] = useState<number>(0);

  const handleInsertNewMusic = async (playlistId: number, url: string) => {
    if (!playlistId) {
      toast.error("Veuillez choisir une playlist", {
        position: "bottom-right",
      });
      return;
    }
    try {
      setLoading(true);
      await axios.post(`${serverUrl}/api/music/insert`, {
        playlistId,
        url,
      });
      toast.success("Musique ajouté !", {
        position: "bottom-right",
      });
    } catch (e: any) {
      if (e.response?.data) {
        toast.error(e.response.data, {
          position: "bottom-right",
        });
      } else {
        toast.error("Une erreur serveur est survenue", {
          position: "bottom-right",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <div className="left-part">
        <Playlist numberOfUserConnected={numberOfUserConnected} />
        <div>
          {currentPlaylist && (
            <div className="add_music_container">
              <MyForm
                onSubmit={(url) =>
                  handleInsertNewMusic(currentPlaylist.id, url)
                }
                placeholder="Type music URL ..."
                buttonText="GO"
                loading={loading}
              />
            </div>
          )}
        </div>
      </div>
      <div className="right-part">
        <MusicPlayer />
      </div>
      <ToastContainer />
    </div>
  );
}

export default App;

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
